import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(
        () => {
            // Update debounced value after delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);
            // Cancel the timeout if value changes (also on delay change or unmount)
            // This is how we prevent debounced value from updating if value is changed ...
            // .. within the delay period. Timeout gets cleared and restarted.
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}

export function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const useSearchParamsHook = ()=>{
    const location = useLocation();

    const history = useHistory();

    const searchparams = React.useMemo(() => {
        return new URLSearchParams(location.search);
    }, [location.search]);

    const setSearchParams = (name , value)=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set(name, value);

        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };
    const clearSearchParams = () => {
        history.replace({
            pathname: location.pathname,
            search: '' // clears all query parameters
        });
    };
    return [searchparams, setSearchParams, clearSearchParams];
};
